import { render, staticRenderFns } from "./SynergismHeaderPrestigeGroup.vue?vue&type=template&id=019433b0&scoped=true&"
import script from "./SynergismHeaderPrestigeGroup.vue?vue&type=script&lang=js&"
export * from "./SynergismHeaderPrestigeGroup.vue?vue&type=script&lang=js&"
import style0 from "./SynergismHeaderPrestigeGroup.vue?vue&type=style&index=0&id=019433b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019433b0",
  null
  
)

export default component.exports